import React from 'react';

function LeftContent( {changeActiveComponent}  ) {

  return (
    <div className="dashboard-left" id="news-section">
    <div className="left-content">
      <div className="news" onClick={() => changeActiveComponent('nestwars')}>
      </div>
    </div>
    </div>
  );
}

export default LeftContent;